export default {
  name: 'ÖVP',
  versions: ['oevp/oevp_1.jpg', 'oevp/oevp_2.jpg'],
  containerStyle: {
    paddingBottom: '10%',
    paddingRight: '10%',
    paddingLeft: '10%'
  },
  baseStyle: {
    fontFamily: '"Geomanist",arial,"sans-serif"',
    fontWeight: '500',
    color: '#FFFFFF',
    display: 'table',
    position: 'relative',
    letterSpacing: '-1px',
    lineHeight: '1.05',
    textShadow:
      '0px 0px 50px rgba(0,0,0,0.5)',
  },
  customStyles: [
    {
      name: "gross",
      style: {
        textAlign: 'left',
        textDecoration: 'underline',
        maxWidth: '70%'
      }
    }
  ],
  linesDefault: [
    {
      text: 'Fehlende Nullen für Wien.',
      style: 0,
      fontSize: 70
    },
  ],
}



// WEBPACK FOOTER //
// ./src/config/oevp.js